/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/jsx-props-no-spreading */
// eslint-disable-next-line import/no-unresolved
import PropTypes from 'prop-types';
import React, { useCallback, useState } from 'react';

import { CheckedState } from '@powdr/constants';

import {
  CheckboxDetails, CheckboxRowWrapper, CheckboxWrapper, StyledCheckbox,
} from './styles';

export const Checkbox = ({
  id = null,
  name,
  label,
  ariaLabel,
  className = '',
  colorProfile = null,
  checked = CheckedState.UNCHECKED,
  isChips = false,
  roundedToggle = false,
  value = null,
  isIgnoreLabelFor = false,
  required = false,
  onChange = () => {},
  additionalData = {},
  details = null,
  children = null,
  style = {},
}) => {
  const [checkboxState, setCheckboxState] = useState(checked !== CheckedState.UNCHECKED);

  const handleCheckedState = useCallback((e) => {
    if (onChange) onChange(e);
    setCheckboxState(e.target.checked);

    e.stopPropagation();
  }, [onChange]);

  return (
    <StyledCheckbox
      className={className}
      style={style}
      isChips={isChips}
      isChecked={checkboxState}
      colorProfile={colorProfile}
      $roundedToggle={roundedToggle}
      $hasDetails={!!details}
    >
      <label
        htmlFor={(!isIgnoreLabelFor) && name}
        className="input-checkbox"
      >
        <input
          id={id || name}
          name={name}
          onChange={(e) => handleCheckedState(e)}
          checked={checkboxState}
          type="checkbox"
          value={value || name}
          aria-label={ariaLabel}
          required={required}
          {...additionalData}
        />
        <CheckboxWrapper>
          <CheckboxRowWrapper>
            {children}
            {label}
          </CheckboxRowWrapper>
          {(details) && <CheckboxDetails $colorProfile={colorProfile}>{details}</CheckboxDetails>}
        </CheckboxWrapper>

      </label>
    </StyledCheckbox>
  );
};

Checkbox.propTypes = {
  className: PropTypes.string,
  style: PropTypes.shape(),
  colorProfile: PropTypes.string,
  checked: PropTypes.oneOf(Object.values(CheckedState)),
  isChips: PropTypes.bool,
  label: PropTypes.string.isRequired,
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
  isIgnoreLabelFor: PropTypes.bool,
  value: PropTypes.string,
  ariaLabel: PropTypes.string.isRequired,
  roundedToggle: PropTypes.bool,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  additionalData: PropTypes.shape(),
  details: PropTypes.string,
  children: PropTypes.node,
};
